// src/NewPassword.js
import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { getAuthUser, clearAuthUser } from './authUserStore';
import './NewPassword.css';

const NewPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  // Haetaan tallennettu CognitoUser globaaleista tiedoista
  const user = getAuthUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Suoritetaan uuden salasanan asetus haasteen täyttämiseksi
      const updatedUser = await Auth.completeNewPassword(user, newPassword);
      console.log('Uusi salasana asetettu onnistuneesti:', updatedUser);
      
      // Tyhjennetään tallennettu käyttäjä
      clearAuthUser();
      
      // Ohjataan käyttäjä dashboard-sivulle
      navigate('/dashboard');
    } catch (error) {
      console.error('Uuden salasanan asettamisvirhe:', error);
      setErrorMessage(error.message || 'Uuden salasanan asettamisessa tapahtui virhe');
    }
  };

  if (!user) {
    return <div>Virhe: käyttäjätietoja ei löytynyt. Kirjaudu uudelleen.</div>;
  }

  return (
    <div className="new-password-container">
      <img src="/stcloud.png" alt="Logo" className="logo" />
      <h2>Aseta uusi salasana</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="newPassword">Uusi salasana</label>
          <input
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Syötä uusi salasana"
            required
          />
        </div>
        {errorMessage && <p className="error">{errorMessage}</p>}
        <button type="submit">Tallenna uusi salasana</button>
      </form>
    </div>
  );
};

export default NewPassword;
